export const apiUrl = "https://api-prod.eschools.tech/api/v1/";
// export const apiUrl = "http://127.0.0.1:8000/api/v1/";
// export const apiUrl = "http://192.168.1.248:8000/api/v1/";
